import magnifyingGlass from 'img/magnifying-glass.svg'
import React from 'react'
import 'css/components/search-bar.css'

export const SearchBar = ({ placeholder = "Search for lessons", onChange }) => {
    return (
        <div className="search-bar">
            <img id="search-button" src={magnifyingGlass} alt="Search" />
            <input
                id="search"
                placeholder={placeholder}
                onChange={onChange}
            />
        </div>
    )
} 